export class Correo {
    to!: string;
    subject!: string;
    message!: string;
}
